import React, { useState, FunctionComponent } from 'react';
import { SupportButton } from '../../../components/Layout/Components/SupportButton';

// Libs
import classnames from 'classnames';

// Contexts
import { useViewDetected } from '@Components/Utils/ViewDetected';

// Components
import Page from '@Components/Utils/Page';
import ComponentLazy from '@Components/Utils/Lazy/Component';
import PlaceholderView from '@Components/UI/PlaceholderView';
import ComingSoon from '@Pages/gioi-thieu/Components/ComingSoon';

// Types
import { NextSeoProps } from 'next-seo';
import { GetServerSideProps, InferGetServerSidePropsType } from 'next';

// Styles
import styles from './IntroClinic.module.scss';

const IntroClinic: FunctionComponent<InferGetServerSidePropsType<typeof getServerSideProps>> = () => {
  const { deviceType } = useViewDetected();

  const isMobile = deviceType !== 'desktop';

  const [isOpen, setIsOpen] = useState<boolean>(false);

  const wrapperClassName = classnames([styles.wrapper, { [styles.mobile]: isMobile }]);

  const toggleModal = () => {
    setIsOpen((currentIsOpen) => !currentIsOpen);
  };

  return (
    <Page className={wrapperClassName}>
      <ComponentLazy
        openModal={toggleModal}
        className={styles.costing}
        dynamic={() => import('@Pages/gioi-thieu/phong-kham/Components/Header')}
        placeholder={() => <PlaceholderView mobileHeight={968} tabletHeight={968} desktopHeight={858} />}
      />

      <ComponentLazy
        className={styles.costing}
        dynamic={() => import('@Pages/gioi-thieu/phong-kham/Components/Middle')}
        placeholder={() => <PlaceholderView mobileHeight={744} tabletHeight={744} desktopHeight={1430} />}
      />

      <ComponentLazy
        openModal={toggleModal}
        className={styles.costing}
        dynamic={() => import('@Pages/gioi-thieu/phong-kham/Components/Footer')}
        placeholder={() => <PlaceholderView mobileHeight={744} tabletHeight={744} desktopHeight={903} />}
      />

      <ComingSoon isOpen={isOpen} onClose={toggleModal} />
      <SupportButton />
    </Page>
  );
};

export default IntroClinic;

export const getServerSideProps: GetServerSideProps = async () => {
  const title = 'eDoctor: Giới thiệu phòng tư vấn';
  const seo: NextSeoProps = {
    title,
    openGraph: {
      title,
      type: 'website',
    },
  };

  return {
    props: {
      seo,
    },
  };
};
